import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import { ITManagedDevicesForm } from "../ITManagedDevices";

const INITIAL_STATE = {
  antivirus: 0,
  proactive_monitoring_coverage: 0,
  proactive_monitoring_protection: 0,
  server_availability: 0,
  patch_management_coverage: 0,
  patch_management_protection: 0,
  failed_login_attempts: 100,
  servers: 0,
  workstations: 0,
  device_monitoring: 0,
  maintenance_alerts_resolved: 0
};

const keys = [
  "antivirus",
  "proactive_monitoring_coverage",
  "proactive_monitoring_protection",
  "server_availability",
  "patch_management_coverage",
  "patch_management_protection",
  "failed_login_attempts",
  "servers",
  "workstations",
  "device_monitoring",
  "maintenance_alerts_resolved"
];

const ITHealthScoreForm = ({
  contract,
  onSubmit,
  savingContract,
  month,
  year
}) => {
  const [inputs, setInputs] = useState(INITIAL_STATE);

  const handleChange = (name, value) => {
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    const index = contract.it_health_scores.findIndex(
      (el) =>
        el.month.toString() === month.toString() &&
        el.year.toString() === year.toString()
    );
    if (index > -1) {
      contract.it_health_scores[index] = { ...inputs, month, year };
    } else {
      contract.it_health_scores.push({ ...inputs, month, year });
    }
    onSubmit(contract);
  };

  useEffect(() => {
    if (!isEmpty(contract)) {
      const healthScoreData =
        contract.it_health_scores.find(
          (el) =>
            el.month.toString() === month.toString() &&
            el.year.toString() === year.toString()
        ) || {};
      const values = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const field in healthScoreData) {
        if (
          Object.prototype.hasOwnProperty.call(healthScoreData, field) &&
          keys.some((key) => key === field) &&
          healthScoreData[field] !== null &&
          healthScoreData[field] !== undefined
        ) {
          values[field] = healthScoreData[field];
        }
      }
      setInputs((prev) => ({ ...prev, ...values }));
    }
  }, [contract, month, year]);

  return (
    <div className="content-wrapper">
      <fieldset>
        <legend>IT Health Score </legend>
      </fieldset>
      <div className="it-hs-form">
        <div>
          <span>Antivirus</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.antivirus}
              name="antivirus"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.antivirus}%`}</span>
          </div>
        </div>

        <div>
          <span>Proactive Monitoring Coverage</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.proactive_monitoring_coverage}
              name="proactive_monitoring_coverage"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.proactive_monitoring_coverage}%`}</span>
          </div>
        </div>

        <div>
          <span>Proactive Monitoring Protection</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.proactive_monitoring_protection}
              name="proactive_monitoring_protection"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.proactive_monitoring_protection}%`}</span>
          </div>
        </div>

        <div>
          <span>Server Availability</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.server_availability}
              name="server_availability"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.server_availability}%`}</span>
          </div>
        </div>

        <div>
          <span>Patch Management Coverage</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.patch_management_coverage}
              name="patch_management_coverage"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.patch_management_coverage}%`}</span>
          </div>
        </div>

        <div>
          <span>Patch Management Protection</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.patch_management_protection}
              name="patch_management_protection"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.patch_management_protection}%`}</span>
          </div>
        </div>

        <div>
          <span>Failed Login Attempts</span>
          <div className="slidecontainer">
            <input
              type="range"
              min="0"
              max="100"
              step="1"
              value={inputs.failed_login_attempts}
              name="failed_login_attempts"
              className="slider"
              onChange={(e) => handleChange(e.target.name, e.target.value)}
            />
            <span>{`${inputs.failed_login_attempts}%`}</span>
          </div>
        </div>
      </div>
      <hr />
      <ITManagedDevicesForm inputs={inputs} onChange={handleChange} />
      <div className="it-hs-form-actions">
        <button
          className="btn btn-success"
          type="button"
          onClick={handleSubmit}
          disabled={savingContract}
        >
          {savingContract ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

ITHealthScoreForm.propTypes = {
  contract: PropTypes.object,
  onSubmit: PropTypes.func,
  savingContract: PropTypes.bool,
  month: PropTypes.string,
  year: PropTypes.string
};

ITHealthScoreForm.defaultProps = {
  contract: {},
  onSubmit: () => null,
  savingContract: false,
  month: "0",
  year: "0"
};

export default ITHealthScoreForm;
